import i18n from '../language/index'
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index.vue'
import Test from '@/test/test.vue'
import Test2 from '@/view/test.vue'
import Download from '@/view/download/index.vue'
import Logout from '@/view/logout/index.vue'
import Login from '@/view/login/index.vue'
import store from '../vuex/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
      alias: '',
      meta: {
        title: i18n.t('router_index_67')
      }
    },
    {
      path: '/test2',
      name: 'test2',
      component: Test2,
      alias: '',
      meta: {
        title: i18n.t('router_index_68')
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      alias: '',
      meta: {
        title: i18n.t('view_login_index_34')
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      alias: '',
      meta: {
        title: i18n.t('view_logout_index_52')
      }
    },
    {
      path: '/downloadFile',
      name: 'downloadFile',
      component: Download,
      alias: '',
      meta: {
        title: i18n.t('router_index_69')
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js